import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(localStorage.getItem('ambassador_token'));
    const [isAuthenticated, setIsAuthenticated] = useState(!!token);

    useEffect(() => {
        // Update isAuthenticated whenever token changes
        setIsAuthenticated(!!token);
    }, [token]);

    const login = async (newToken, newId) => {
        // Set token in localStorage first
        localStorage.setItem('ambassador_token', newToken);
        localStorage.setItem('ambassador_id', newId);
        // Then update state
        setToken(newToken);
        // Return a promise that resolves when the state is updated
        return new Promise((resolve) => {
            setTimeout(resolve, 0);
        });
    };

    const logout = () => {
        localStorage.removeItem('ambassador_token');
        setToken(null);
    };

    return (
        <AuthContext.Provider value={{ token, isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
}; 